const relIcon = 'icon';
const relATI = 'apple-touch-icon';
const relATIPrecomposed = 'apple-touch-icon-precomposed';
const imgType = 'image/png';

const dataIcons = [
  [relIcon, 'image/x-icon', '48x48', '/favicon.ico'],
  [relIcon, imgType, '16x16', '/favicon-16x16.png'],
  [relIcon, imgType, '32x32', '/favicon-32x32.png'],
  [relIcon, imgType, '96x96', '/favicon-96x96.png'],
  [relIcon, imgType, '192x192', '/android-icon-192x192.png'],
  [relIcon, imgType, '512x512', '/android-icon-512x512.png'],
  ['mask-icon', imgType, null, '/safari-pinned-tab.svg'],
  [relATI, imgType, null, '/apple-icon.png'],
  [relATIPrecomposed, imgType, null, '/apple-icon-precomposed.png'],
  [relATI, imgType, '57x57', '/apple-icon-57x57.png'],
  [relATIPrecomposed, imgType, '57x57', '/apple-icon-57x57-precomposed.png'],
  [relATI, imgType, '60x60', '/apple-icon-60x60.png'],
  [relATIPrecomposed, imgType, '60x60', '/apple-icon-60x60-precomposed.png'],
  [relATI, imgType, '72x72', '/apple-icon-72x72.png'],
  [relATIPrecomposed, imgType, '72x72', '/apple-icon-72x72-precomposed.png'],
  [relATI, imgType, '76x76', '/apple-icon-76x76.png'],
  [relATIPrecomposed, imgType, '76x76', '/apple-icon-76x76-precomposed.png'],
  [relATI, imgType, '114x114', '/apple-icon-114x114.png'],
  [relATIPrecomposed, imgType, '114x114', '/apple-icon-114x114-precomposed.png'],
  [relATI, imgType, '120x120', '/apple-icon-120x120.png'],
  [relATIPrecomposed, imgType, '120x120', '/apple-icon-120x120-precomposed.png'],
  [relATI, imgType, '144x144', '/apple-icon-144x144.png'],
  [relATIPrecomposed, imgType, '144x144', '/apple-icon-144x144-precomposed.png'],
  [relATI, imgType, '152x152', '/apple-icon-152x152.png'],
  [relATIPrecomposed, imgType, '152x152', '/apple-icon-152x152-precomposed.png'],
  [relATI, imgType, '180x180', '/apple-icon-180x180.png'],
  [relATIPrecomposed, imgType, '180x180', '/apple-icon-180x180-precomposed.png'],
];

export const ICONS = dataIcons.map(([rel, type, sizes, href]) => ({ rel, type, sizes, href }));
